import React, { useState } from 'react';
import { mythById, mythPath, badgeClass } from '../../utils/myths';
import { slugify } from '../../utils/slugify';

// The "Breaking" verdict ticker. Links point at each myth's own page (what a
// crawler follows); on the homepage a click pops that myth in the desk instead.
const TICKER_IDS = [1, 9, 20, 19, 36, 7, 14, 8];

export default function Ticker() {
  const [paused, setPaused] = useState(false);
  const items = TICKER_IDS.map(mythById).filter(Boolean);

  const popOnPage = (e, s) => {
    if (!document.querySelector('[data-fi-desk]')) return;
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('fi:pop', { detail: slugify(s.title) }));
  };

  const row = (keyPrefix, hidden) => items.map((s) => (
    <a
      key={`${keyPrefix}-${s.id}`}
      href={mythPath(s)}
      onClick={(e) => popOnPage(e, s)}
      tabIndex={hidden ? -1 : undefined}
      aria-hidden={hidden || undefined}
    >
      {s.title} <em className={badgeClass(s)}>{s.titleBadge}</em>
    </a>
  ));

  return (
    <div className={`fi-ticker${paused ? ' is-paused' : ''}`} data-track-context="home_ticker">
      <div className="fi-ticker-label"><i aria-hidden="true" />Breaking</div>
      <div className="fi-ticker-view">
        <div className="fi-ticker-track">
          {row('a', false)}
          {row('b', true)}
        </div>
      </div>
      <button type="button" className="fi-ticker-pause" onClick={() => setPaused(!paused)} aria-pressed={paused}>
        {paused ? 'Play' : 'Pause'}
      </button>
    </div>
  );
}
